import Vue from 'vue'
import VueRouter from 'vue-router'
import routerPlus from './routerPlus'
import store from '../store/index'
import { flatten } from 'lodash'
import { stringifyQuery, parseQuery } from '@/utils/query/query'
import { envConfig } from '@const/env';
const { MODE, assetsPublicPath } = envConfig();

console.log('router获取环境变量', MODE, assetsPublicPath);

// 模块引入
function getModules() {
  const modulesFiles = require.context('./module', false, /\.js$/)
  const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    // set './app.js' => 'app'
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
    const value = modulesFiles(modulePath)
    modules[moduleName] = value.default
    return modules
  }, {})
  return modules
}
// 配置路由
const routes = [
  { path: '/', redirect: '/home' },
  ...flatten(Object.values(getModules())),
  {
    path: '*',
    redirect: '/home'
  }
]
// 注册路由
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: assetsPublicPath,
  routes,
  //启用html5 history模式的时候生效，用于后退操作的时候记住之前的滚动条位置
  // saveScrollPosition: true
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
  stringifyQuery,
  parseQuery
})

// 使用 beforeEach 路由守卫
router.beforeEach((to, from, next) => {
  // 更新页面头部 用于控制头部菜单交互
  store.dispatch('updateName', to.name)
  next()
})

export { routes }
routerPlus(router, routes)
export default router



// WEBPACK FOOTER //
// ./src/routers/index.js